module.exports = __webpack_public_path__ + "static/stopklatka-2-2a0dbcbe640892a503cc8cd78330a44e.jpg";